import { z } from 'zod'

export const GROUP_TAG_REGEX = /^[\p{L}\p{N}_-]{1,30}$/u

export const groupTagSchema = z
  .string()
  .regex(GROUP_TAG_REGEX, 'Tag must be 1-30 letters, digits, hyphens, or underscores')

export const groupTagOrEmptySchema = z.union([z.literal(''), groupTagSchema])
